export default ({ palette, typography }) => ({
  wrap: {
    color: palette.text.dark,
    borderRadius: 4,
    fontSize: 14,
    ...typography.text
  },
  positive: {
    border: '1px solid',
    borderColor: '#8cb566',
    backgroundColor: '#dff0d6'
  },
  warning: {
    border: '1px solid',
    borderColor: '#fad335',
    backgroundColor: '#fff7d7'
  },
  negative: {
    border: '1px solid',
    borderColor: '#97030a',
    backgroundColor: '#fecccd'
  },
  info: {
    border: '1px solid',
    borderColor: '#4c89c6',
    backgroundColor: '#e8f3ff'
  },
  alertTitle: {
    margin: 0,
    textTransform: 'none'
  },
  alertIcon: {
    margin: [16, 8, 20, 15],
    '& svg': {
      width: 14,
      height: 14,
      fill: palette.text.dark,
      opacity: 0.3
    }
  },
  alertDetails: {
    marginTop: 15
  },
  btnDetails: {
    position: 'absolute',
    right: 100,
    top: 15,
    height: 16
  },
  labelDetails: {
    position: 'absolute',
    top: 0,
    left: 0,
    color: palette.text.dark,
    fontSize: 14,
    fontWeight: 'normal'
  },
  IconDetails: {
    position: 'absolute',
    top: 0,
    left: -25,
    '& svg': {
      fill: palette.text.dark,
      opacity: 0.3
    }
  },
  alertMessage: {
    fontSize: 14,
    margin: [0, 0, 10]
  },
  closeButton: {
    margin: [15, 15, 15, 10],
    '& svg': {
      fill: palette.text.dark,
      height: 16,
      opacity: 0.2,
      '&:hover': {
        opacity: 0.5
      }
    }
  },
  focusColor: palette.focus.normal
});
